(function () {
  const OPEN = '[data-ring-size-modal-open]';
  const MODAL_ROOT = '[data-ring-size-modal]';
  const CLOSE = '[data-ring-size-modal-close]';

  function moveModalsToBody() {
    document.querySelectorAll(MODAL_ROOT).forEach((modal) => {
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  function init() {
    moveModalsToBody();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  function getModalFromTrigger(trigger) {
    const id = trigger.getAttribute('aria-controls');
    if (id) {
      const el = document.getElementById(id);
      if (el) return el;
    }
    return document.querySelector(MODAL_ROOT);
  }

  function openModal(modal, trigger) {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('prevent-scroll');
    modal.__ringSizeTrigger = trigger || null;
    const closeBtn = modal.querySelector('.ring-size-help-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('prevent-scroll');
    const t = modal.__ringSizeTrigger;
    if (t && document.body.contains(t)) t.focus();
    modal.__ringSizeTrigger = null;
  }

  function onDocClick(e) {
    const trigger = e.target.closest(OPEN);
    if (trigger) {
      e.preventDefault();
      const modal = getModalFromTrigger(trigger);
      openModal(modal, trigger);
      return;
    }
    const closeEl = e.target.closest(CLOSE);
    if (closeEl) {
      const modal = closeEl.closest(MODAL_ROOT);
      closeModal(modal);
    }
  }

  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    const open = document.querySelector(`${MODAL_ROOT}.is-open`);
    if (open) {
      e.preventDefault();
      closeModal(open);
    }
  }

  document.addEventListener('click', onDocClick);
  document.addEventListener('keydown', onKeydown);
})();
